import React, { useContext, useMemo } from 'react'
import classnames from 'classnames'
import { IoMdSend } from 'react-icons/io'
import { IconButton } from 'components'
import { I18nContext } from 'i18n'

const SendForReviewButton = ({ className, label, disabled, variant, ...rest }) => {
  const { translate } = useContext(I18nContext)
  const iconText = useMemo(
    () => label || translate('send_all_for_review'),
    [translate, label],
  )
  return (
    <IconButton
      icon={<IoMdSend />}
      text={iconText}
      className={classnames(className, 'small', 'rounded')}
      disabled={disabled}
      variant={disabled ? null : variant}
      {...rest}
    />
  )
}

export default SendForReviewButton
